(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-custom-product-carousel-root]').forEach(function (root) {
    var track = root.querySelector('[data-custom-product-carousel-track]');
    var prev = root.querySelector('[data-custom-product-carousel-prev]');
    var next = root.querySelector('[data-custom-product-carousel-next]');
    if (!track || !prev || !next) return;
    function amount() {
      return Math.max(Math.floor(track.clientWidth * 0.88), 240);
    }
    prev.addEventListener('click', function () {
      track.scrollBy({ left: -amount(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: amount(), behavior: 'smooth' });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
